import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space, Icon } from '@redlink/components/atoms';
import { useLocale } from '@redlink/assets/locale';

export const InnerLinkChildItem = memo(
  ({
    item: {
      id,
      title,
      url,
      createDate,
      logoName,
      shortLinkUrl,
      totalHit,
      isVisible,
    } = {},
  }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();
    return (
      <View style={styles.container}>
        <View style={styles.bodyContainer}>
          <Icon name={logoName} size={16} color={colors.gray21} />
          <Space size={16} />
          <View style={styles.textContainer}>
            <Text style={styles.titleText}>{title}</Text>
            <Text en style={styles.subtitleText} numberOfLines={1}>
              {url}
            </Text>
          </View>
        </View>
        <Space size={24} />
        <View>
          <Text style={styles.titleText}>{totalHit}</Text>
          <Text style={styles.subtitleText}>{dictionary.totalHit}</Text>
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  titleText: {
    fontSize: 14,
    color: colors.gray23,
    textAlign: 'left',
  },
  subtitleText: {
    fontSize: 12,
    color: colors.gray21,
    textAlign: 'left',
  },
  textContainer: {
    flex: 1,
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bodyContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
}));
